import { Book, LucideIcon, PhoneCall, Wrench } from 'lucide-react'

import { PageHeader } from '@/components/common/navigation/PageHeader'
import { useAuthStore } from '@/features/sessao/store/useAuthStore'

import { useTarefas } from '../../hooks/use-tarefas'
import { TodoList } from './components/todo-list'

type TaskContent = {
  id: string | number
  title: string
  description: string
  icon: LucideIcon
  url: string
}

type TaskData = {
  contracts: Array<TaskContent>
  calls: Array<TaskContent>
  orders: Array<TaskContent>
}

export default function Component() {
  const { user } = useAuthStore()

  const { data, isFetching, refetch } = useTarefas(user?.id)

  const taskData: TaskData = {
    calls:
      data?.calls.map((ea) => ({
        id: ea.id,
        title: `O chamado ${ea.id} requer sua atenção`,
        description: ea.description || '',
        icon: PhoneCall,
        url: `/app/entity/chamados/${ea.id}/detalhes`,
        createdAt: ea.createdAt,
      })) || [],
    orders:
      data?.orders.map((ea) => ({
        id: ea.id,
        title: `A ordem ${ea.id} requer sua atenção`,
        description: ea.defect || '',
        icon: Wrench,
        url: `/app/entity/ordens/servico/${ea.id}/detalhes`,
        createdAt: ea.created_at,
      })) || [],
    contracts:
      data?.contracts.map((ea) => ({
        id: ea.id,
        title: `O contrato ${ea.id} requer sua atenção`,
        description: 'Contrato prestes à vencer',
        icon: Book,
        url: `/app/entity/contratos/${ea.id}/detalhes`,
        createdAt: ea.createdAt,
      })) || [],
  }

  return (
    <>
      <PageHeader title="Dashboard" />
      <div className="p-8">
        <TodoList data={taskData} isFetching={isFetching} refetch={refetch} />
      </div>
    </>
  )
}
